import { OrderState } from '@common/Checkout/Checkout/types';
import { OrderReducer } from '@common/Checkout/Checkout/types/reducers';
import { RECEIVE_ORDER } from '../actions/constants';

const initialState: OrderState = {
    address: null,
    banners: [],
    baseItemsPrice: '',
    checkoutBanners: [],
    club: null,
    currency: null,
    discountValue: null,
    estimatedShippingPrice: '',
    fees: [],
    finalPrice: '',
    giftCard: null,
    id: null,
    isTestOrder: false,
    items: [],
    itemsPrice: '',
    payment: null,
    prefillGiftCard: null,
    prefillVoucher: null,
    prefixedId: '',
    shipping: null,
    shippingFee: '',
    shippingListTypes: [],
    shippings: [],
    totalBasePrice: '',
    totalDiscount: null,
    totalPrice: '',
    totalVatValue: null,
    trackingData: null,
    vatExcluded: false,
    voucher: null,
    voucherValue: null,
    xForYDiscount: null,
    paymentSummary: [],
    legalSection: {
        showClubSignUp: false,
        showSubscription: false,
        showTermsAndConditions: false,
    },
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: OrderReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case RECEIVE_ORDER: {
            const { payload } = action;

            return { ...state, ...payload };
        }

        default:
            return state;
    }
};

export default reducer;
